import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const CountriesActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <defs>
      <linearGradient
        id="csdc0j4k4a"
        x1="138.239%"
        x2="0%"
        y1="47.412%"
        y2="50.911%"
      >
        <stop offset="0%" stopColor="#7CD5F6" />
        <stop offset="100%" stopColor="#46AAE9" />
      </linearGradient>
      <linearGradient
        id="i26eebusob"
        x1="148.708%"
        x2="-13.986%"
        y1="4.644%"
        y2="21.006%"
      >
        <stop offset="0%" stopColor="#7CD5F6" />
        <stop offset="100%" stopColor="#46AAE9" />
      </linearGradient>
      <linearGradient
        id="72sfey3lcc"
        x1="157.143%"
        x2="-25.025%"
        y1="80.092%"
        y2="56.711%"
      >
        <stop offset="0%" stopColor="#7CD5F6" />
        <stop offset="100%" stopColor="#46AAE9" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <path
            fill="#46AAE9"
            d="M2.11 19.112l-1.03-4.115s0-.516.722-.206l4.57 4.673-4.262-.352"
            transform="translate(-133 -992) translate(133 988) rotate(-34 3.726 17.078)"
          />
          <path
            fill="#46AAE9"
            d="M5.134 19.528l-1.03 4.113s0 .516.722.208l4.57-4.674-4.262.353"
            transform="translate(-133 -992) translate(133 988) rotate(-34 6.75 21.56)"
          />
          <path
            fill="url(#csdc0j4k4a)"
            d="M22.456 12.418c.829 0 1.5.672 1.5 1.5 0 .78-.594 1.42-1.355 1.493l-.145.007H3.228c-.829 0-1.5-.672-1.5-1.5 0-.78.595-1.42 1.355-1.493l.145-.007h19.228z"
            transform="translate(-133 -992) translate(133 988) rotate(-34 12.842 13.918)"
          />
          <path
            fill="url(#i26eebusob)"
            d="M12.18 24.361s0 1.104.62.691c.62-.416 8.52-12.474 8.52-12.474l-6.97 1.023-2.17 10.76z"
            transform="translate(-133 -992) translate(133 988) rotate(-34 16.75 18.861)"
          />
          <path
            fill="url(#72sfey3lcc)"
            d="M7.323 13.701L5.153 2.942s0-1.104.62-.689c.62.413 8.519 12.473 8.519 12.473l-6.97-1.025"
            transform="translate(-133 -992) translate(133 988) rotate(-34 9.722 8.443)"
          />
        </g>
      </g>
    </g>
  </SvgWrapper>
)
